import { Denuncia } from './denuncia.model';

export class KanbanDenuncia {
  titulo:  string;
  icono:   string;
  color:   string;
  lista:   Denuncia[];

  constructor(titulo: string, lista: Denuncia[], icono: string, color: string) {
    this.titulo = titulo;
    this.lista  = lista;
    this.icono  = icono;
    this.color  = color;
  }
}
